import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { SaleSerializer } from './sale.serializer'

@Injectable()
export class SaleDocumentService {
  // TODO create some resource service to extend that works for services like this
  constructor(private http: HttpClient, private serializer: SaleSerializer) {}

  public createOne(saleId: number, documentId: number): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/sales/${saleId}/sale-document`,
      { saleId, documentId }
    )
  }

  public deleteOne(saleId: number, documentId: number): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/sales/${saleId}/sale-document/${documentId}`
    )
  }
}
